import React from "react";
import { motion } from "framer-motion";
import { FcGoogle } from "react-icons/fc";
import TestimonialCard from "./TestimonialCard";
import { useLanguage } from "../context/LanguageContext";

const defaultTestimonials = [
  {
    quote:
      "Iryna has been handling our accounting and bookkeeping, and we couldn't be more satisfied with her services. She is incredibly responsive, highly organized, and ensures that everything is kept on track. Her extensive knowledge and attention to detail give us complete confidence in our financial management. Highly recommend her for anyone looking for reliable and professional bookkeeping services!",
    author: "Vlad Ignatenko",
    company: "North Star Inc.",
    rating: 5,
  },
  {
    quote:
      "Iryna has been our in-house bookkeeper for a couple of years now and we only have wonderful words to say about her personality and services. Everything is always done on time and in a most efficient way. Iryna has been doing our payroll, accounts receivable/payable, T4s, monthly financing reports, and more. Highly recommended!",
    author: "Yevgeniy Gorlov",
    company: "Art Metal Workshop Inc.",
    rating: 5,
  },
  {
    quote:
      "I've had an excellent experience with IRAs. Iryna is a great professional, detail-oriented, and incredibly efficient, helping me streamline my finances with accurate and up-to-date records. Always responsive and goes the extra mile to explain everything clearly. Whether it's tax preparation, monthly reports, or financial advice, their service is top-notch. If you're looking for reliable and stress-free bookkeeping, I highly recommend IRAs!",
    author: "Anastasia Kostiuk",
    company: "Ginger Agency",
    rating: 5,
  },
];

const googleReviewsLink = "https://g.co/kgs/YBTGJgc";

const Testimonials = ({ testimonials = defaultTestimonials }) => {
  const { t } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="text-center py-28 space-y-10 bg-gradient-to-br from-gray-100 to-yellow-50"
    >
      <h2 className="text-5xl font-bold text-yellow-600">{t("testimonials.title")}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-6 md:px-12">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={`${testimonial.author}-${index}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            whileHover={{ scale: 1.07 }}
            className="transition-all duration-300"
          >
            <TestimonialCard
              quote={testimonial.quote}
              author={testimonial.author}
              company={testimonial.company}
              rating={testimonial.rating}
            />
          </motion.div>
        ))}
      </div>

      <div className="mt-10 flex justify-center">
        <a
          href={googleReviewsLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 bg-white shadow-lg px-6 py-3 rounded-full transition-transform hover:scale-105"
        >
          <FcGoogle className="text-3xl" />
          <span className="text-lg font-semibold text-gray-800">{t("testimonials.seeMore")}</span>
        </a>
      </div>
    </motion.div>
  );
};

export default Testimonials;
